import { CrudService } from './CrudService';
import { resources } from '../resources';
import { EstablishmentQueryParams } from '../params/EstablishmentQueryParams';
import { EstablishmentDto } from '../models/establishment/EstablishmentDto';
import { AxiosConfig, AxiosPagePromise } from './BaseService';
import { Page } from '../models/common/Page';
import { AxiosPromise } from 'axios';
import { ReferenceDto } from '../models/employees/ReferenceDto';

export class EstablishmentService extends CrudService<EstablishmentDto, EstablishmentQueryParams> {
  constructor() {
    super({
      query: resources.queryEstablishments,
      get: resources.getEstablishment,
      create: resources.createEstablishment,
      update: resources.updateEstablishment,
      idKey: 'establishmentId',
    });
  }

  public queryAllEstablishments(args?: EstablishmentQueryParams, options: AxiosConfig = {}): AxiosPagePromise<EstablishmentDto> {
    return this.get<Page<EstablishmentDto>>(resources.queryAllEstablishments, args, options);
  }

  public getLatestEstablishmentsUsedBy(userId?: string, options: AxiosConfig = {}): AxiosPromise<ReferenceDto[]> {
    return this.get<ReferenceDto[]>(resources.getLatestEstablishmentsUsedBy, userId ? { userId } : undefined, options);
  }
}
